<div class="desktop">
  <div class="subheader" style="margin-bottom: 1.25rem;">
    <ng-container i18n>Amenities</ng-container>
  </div>
  <div>
    <div class="flex wrap amenities">
      <div style="display: flex; align-items: center" *ngFor="let a of (hostel?.amenities ?? [])">
        <svg-icon style="margin-right: 5px; display: inline-flex" [svgStyle]="{'width.px': 20, 'height.px': 20}" [src]="a.icon"></svg-icon>
        {{a.names | lang : 'en'}}
      </div>
    </div>
  </div>
</div>

<div class="mobile">
  <div class="wrapper">
    <h3>
      <ng-container i18n>Amenities</ng-container>
    </h3>
    <div>
      <div class="flex wrap amenities">
        <div style="display: flex; align-items: center" *ngFor="let a of top10Amenities">
          <svg-icon style="margin-right: 5px; display: inline-flex" [svgStyle]="{'width.px': 20, 'height.px': 20}" [src]="a.icon"></svg-icon>
          {{a.names | lang : 'en'}}
        </div>
      </div>
    </div>
  </div>
  <div class="button-wrapper" *ngIf="(hostel?.amenities?.length ?? 0) > 10">
    <button class="btn btn-theme btn-large">
      <ng-container i18n>View all&nbsp;{{hostel?.amenities?.length}}&nbsp;Amenities</ng-container>
    </button>
  </div>
</div>
